// Any user settings overrides those of the practice, and those of a practice override those of an institution
export const determineEffectiveSettings = (
  institution = {},
  practice = {},
  user = {},
) => {
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type '{}'.
  const { settings: institutionSettings } = institution;
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type '{}'.
  const { settings: practiceSettings } = practice;
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type '{}'.
  const { settings: userSettings } = user;

  return {
    ...institutionSettings,
    ...practiceSettings,
    ...userSettings,
  };
};
